import type {
  ParseTemplateProps,
  ProviderSourceInfo,
  TemplateInfo,
  TemplateType,
} from '@/modules/ab-testing/types/template';

import { ProviderSource } from '@/modules/ab-testing/types/template';
import {
  regexTemplateOrigin,
  regexTemplateV6,
  regexTemplateV7,
  regexTemplateGemX,
  regexTemplatePageFly,
  regexTemplateFoxify,
  regexTemplateEComposer,
  regexTemplateShopify,
  regexTemplateIdV6,
  regexTemplateIdV7,
} from '@/modules/ab-testing/constants/templateRegex';

export const parseShopifyOriginTemplate = ({
  assetKey,
  providerSourceInfo,
}: ParseTemplateProps): TemplateInfo | undefined => {
  const { regex: regexTemplateOrigin, providerSource } = providerSourceInfo;
  const match = regexTemplateOrigin.exec(assetKey);
  if (!match) return;

  const [, type, fileExtension] = match;
  return {
    suffix: type,
    type: type as TemplateType,
    fileExtension: fileExtension as TemplateInfo['fileExtension'],
    providerSource,
  };
};

export const parseShopifyTemplate = ({
  assetKey,
  providerSourceInfo,
}: ParseTemplateProps): TemplateInfo | undefined => {
  const { regex, providerSource } = providerSourceInfo;
  const match = regex.exec(assetKey);
  if (!match) return;

  const [, type, suffix, fileExtension] = match;
  return {
    type: type as TemplateType,
    suffix: suffix,
    fileExtension: fileExtension as TemplateInfo['fileExtension'],
    providerSource,
  };
};

export const parseProviderSources: ProviderSourceInfo[] = [
  {
    providerSource: ProviderSource.SHOPIFY_ORIGIN,
    regex: regexTemplateOrigin,
    parseTemplate: parseShopifyOriginTemplate,
  },
  {
    providerSource: ProviderSource.GEMPAGESV6,
    regex: regexTemplateV6,
    regexId: regexTemplateIdV6,
    parseTemplate: parseShopifyTemplate,
  },
  {
    providerSource: ProviderSource.GEMPAGESV7,
    regex: regexTemplateV7,
    regexId: regexTemplateIdV7,
    parseTemplate: parseShopifyTemplate,
  },
  {
    providerSource: ProviderSource.SHOPIFY_GEMX,
    regex: regexTemplateGemX,
    parseTemplate: parseShopifyTemplate,
  },
  {
    providerSource: ProviderSource.SHOPIFY_PAGE_FLY,
    regex: regexTemplatePageFly,
    parseTemplate: parseShopifyTemplate,
  },
  {
    providerSource: ProviderSource.SHOPIFY_FOXIFY,
    regex: regexTemplateFoxify,
    parseTemplate: parseShopifyTemplate,
  },
  {
    providerSource: ProviderSource.SHOPIFY_ECOMPOSER,
    regex: regexTemplateEComposer,
    parseTemplate: parseShopifyTemplate,
  },
  {
    providerSource: ProviderSource.SHOPIFY,
    regex: regexTemplateShopify,
    parseTemplate: parseShopifyTemplate,
  },
];
